import gql from 'graphql-tag';

export const GET_CUSTOMERS_SEGMENTS = gql`
  query getCustomersSegments {
    customersSegments {
      customersCount
      key
    }
  }
`;

export const GET_CUSTOMERS_SEGMENT = gql`
  query getCustomersSegment(
    $pagination: PaginationAttributes!
    $segmentName: String!
  ) {
    customersSegment(
      pagination: $pagination
      segmentName: $segmentName
    ) {
      email
      fullName
      id
      lastMessageAt
      mobilePhone
    }
  }
`;

export const CREATE_CUSTOM_MESSAGE = gql`
  mutation createCustomMessage($input: CreateCustomMessageInput!) {
    createCustomMessage(input: $input) {
      customMessage
    }
  }
`;

export const SEND_MESSAGE_TO_CUSTOMERS_SEGMENT = gql`
  mutation sendMessageToCustomersSegment($input: SendMessageToCustomersSegmentInput!) {
    sendMessageToCustomersSegment(input: $input) {
      status
    }
  }
`;

export const GET_MESSAGING_EMAIL_TEMPLATE = gql`
  query getMessagingEmailTemplate($id: ID!) {
    messagingEmailTemplate(id: $id) {
      id
      content
      subject
    }
  }
`;
